import { QRCodeSVG } from "qrcode.react";
import { Mail, Phone, Globe, Printer, Check } from "lucide-react";
import { LogoMark } from "../components/site/Logo";
import { CONTACT, DISCOUNTS } from "../components/site/content";
import "./flyer.css";

const SHORT = {
  "good-student": "Strong grades can lower the premium.",
  "away-at-school": "College 100+ miles away without a car? It can count.",
  "driver-training": "Approved driver ed, like Joshua's Law courses.",
  telematics: "A safe-driving app that rewards good habits.",
};

const Head = () => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-3">
      <LogoMark className="h-12 w-12" />
      <div className="leading-none">
        <p className="font-display text-3xl font-black uppercase text-bone">ShieldTeen</p>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-mist">by Hunt Shield Insurance</p>
      </div>
    </div>
    <p className="rounded-full border border-lane/50 px-4 py-2 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-lane">Licensed P&amp;C Agent · Georgia</p>
  </div>
);

const Discount = ({ d }) => (
  <div className="rounded-2xl border border-white/10 bg-graphite p-4" data-testid={`flyer-discount-${d.id}`}>
    <div className="flex items-center gap-2">
      <Check className="h-4 w-4 text-lane" />
      <p className="font-display text-xl font-black uppercase leading-none text-bone">{d.title}</p>
    </div>
    <p className="mt-2 font-body text-[12px] leading-snug text-mist">{SHORT[d.id]}</p>
  </div>
);

const ContactBlock = () => (
  <div className="flex items-stretch gap-4 rounded-3xl bg-lane p-5 text-asphalt" data-testid="flyer-contact">
    <div className="flex flex-1 flex-col justify-center gap-2">
      <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em]">Call for your teen quote</p>
      <p className="flex items-center gap-3 font-display text-5xl font-black leading-none" data-testid="flyer-phone"><Phone className="h-8 w-8" />{CONTACT.phone}</p>
      <p className="mt-1 flex items-center gap-2 font-body text-[15px] font-bold" data-testid="flyer-email"><Mail className="h-4 w-4" />{CONTACT.email}</p>
      <p className="flex items-center gap-2 font-body text-[15px] font-bold" data-testid="flyer-website"><Globe className="h-4 w-4" />www.{CONTACT.domain}</p>
    </div>
    <div className="flex flex-col items-center justify-center rounded-2xl bg-white p-3">
      <QRCodeSVG value={`https://www.${CONTACT.domain}`} size={104} fgColor="#0A0D12" data-testid="flyer-qr" />
      <p className="mt-1 font-mono text-[9px] font-bold uppercase tracking-widest">Scan to visit</p>
    </div>
  </div>
);

export default function Flyer() {
  return (
    <div className="flyer-screen min-h-screen bg-[#2a2f38] py-10" data-testid="flyer-page">
      <div className="no-print mx-auto mb-6 flex max-w-[816px] flex-col gap-3 px-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-body text-sm text-bone">Letter size (8.5 × 11 in). Use "Save as PDF" to download.</p>
        <button onClick={() => window.print()} data-testid="flyer-print-btn" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-lane px-5 py-2.5 font-body text-sm font-bold text-asphalt transition-transform hover:-translate-y-0.5">
          <Printer className="h-4 w-4" /> Print / Save as PDF
        </button>
      </div>
      <article className="flyer-sheet relative mx-auto flex flex-col overflow-hidden bg-asphalt px-12 py-10 text-bone shadow-2xl">
        <Head />
        <div className="mt-8 grid grid-cols-[1.15fr_1fr] gap-6">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-lane/15 px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-lane">
              <span className="rounded-full bg-lane px-2 py-0.5 text-asphalt">New</span> Safe Driver Program
            </p>
            <h1 className="mt-5 font-display text-[78px] font-black uppercase leading-[0.86]">
              Keys in hand.<br />Costs in <span className="text-lane">check.</span>
            </h1>
            <p className="mt-5 font-body text-[14px] leading-relaxed text-mist">
              New teen driver in the family? Parents, don't let the quote scare you. Hunt Shield Insurance explains every discount your teen may qualify for and helps you stack them.
            </p>
          </div>
          <div className="flyer-clip relative h-[330px] overflow-hidden">
            <img src="/img/hero.jpg" alt="Teen driver smiling in the car" className="h-full w-full object-cover" />
          </div>
        </div>
        <p className="mt-7 font-mono text-[11px] uppercase tracking-[0.28em] text-lane">Ask about these 4 teen discounts</p>
        <div className="mt-3 grid grid-cols-2 gap-3">
          {DISCOUNTS.map((d) => <Discount key={d.id} d={d} />)}
        </div>
        <div className="mt-auto pt-6">
          <ContactBlock />
          <p className="mt-4 font-body text-[9px] leading-snug text-mist">
            {CONTACT.agency} · Licensed Property &amp; Casualty Insurance Agent in Georgia. Discount availability, eligibility and amounts vary by insurance company and individual circumstances. Not a quote or guarantee of coverage or savings.
          </p>
        </div>
      </article>
    </div>
  );
}
